import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { Form } from 'react-bootstrap';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import { GetMasterItemsById, getNewItemBarcode, UpdatMasterItems } from '@store/INV/MasterItems/MasterItemsSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';
import useLookupGetItemType from '@hooks/Lookups/use-Lookup-GetItemType';
import { MasterItemsSchema } from '../../../../ValidationForm/validationSchema';
import useGetBrandList from '@hooks/INV/Brand/useGetBrandList';
import Loading from '@components/Shared/Loader/Loading';
import { useEffect, useState } from 'react';
import { Card, CardBody } from '@components/card/card';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import useLookupGetExpenseDistribute from '@hooks/Lookups/use-Lookup-GetExpenseDistribute';
import useGetTaxCategory from '@hooks/Lookups/use-Get_TaxCategory';

const Update = ({ MasterItemsById }: any) => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const { CategoriesList } = useGetCategoriesList();
  const dispatch = useAppDispatch();
  const { UnitsOfMeasureList } = useGetUnitsOfMeasureList();
  const { ITEM_TYPE } = useLookupGetItemType();
  const { BrandListOptions, loading: loading4 } = useGetBrandList();
  const [activeTab, setActiveTab] = useState('basic');
  const { TaxCategory, loading: loading6 } = useGetTaxCategory();
  const { ExpenseDistribute, loading: loading5 } = useLookupGetExpenseDistribute();
  const [loadBarcode, setLoadBarcode] = useState(false);

  // const { MasterItemsById, loading, error } = useAppSelector(a => a.MasterItemsINV);
  // useEffect(() => {
  //   if (ItemId) {
  //     dispatch(GetMasterItemsById(ItemId));
  //   }
  // }, [ItemId]);

  // دالة توليد باركود من السيرفر
  const generateBarcode = async () => {
    try {
      setLoadBarcode(true);
      const res = await dispatch(getNewItemBarcode()).unwrap();
      if (res.succeeded === true) {
        formik.setFieldValue('barcode', res.data);
      } else {
        formik.setFieldValue('barcode', '0');
      }
    } catch (error) {
      formik.setFieldValue('barcode', '0');
    } finally {
      setLoadBarcode(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      id: MasterItemsById ? MasterItemsById.id : null,
      itemCode: MasterItemsById ? MasterItemsById.itemCode : '',
      barcode: MasterItemsById ? MasterItemsById.barcode : '',
      name: MasterItemsById ? MasterItemsById.name : '',
      name2: MasterItemsById ? MasterItemsById.name2 : '',
      categoryId: MasterItemsById ? MasterItemsById.categoryId : '',
      // typeId: MasterItemsById ? MasterItemsById.typeId : "",

      displayName: MasterItemsById ? MasterItemsById.displayName : '',
      displayName2: MasterItemsById ? MasterItemsById.displayName2 : '',
      itemType: MasterItemsById ? MasterItemsById.itemType : '',
      serviceItemFlag: MasterItemsById ? MasterItemsById.serviceItemFlag : false,
      isActive: MasterItemsById ? MasterItemsById.isActive : false,
      purchasingEnabledFlag: MasterItemsById ? MasterItemsById.purchasingEnabledFlag : false,
      customerOrderEnabledFlag: MasterItemsById ? MasterItemsById.customerOrderEnabledFlag : false,
      internalOrderEnabledFlag: MasterItemsById ? MasterItemsById.internalOrderEnabledFlag : false,
      soTransactionsFlag: MasterItemsById ? MasterItemsById.soTransactionsFlag : false,
      invTransactionsEnabledFlag: MasterItemsById ? MasterItemsById.invTransactionsEnabledFlag : false,
      salesPrice: MasterItemsById ? MasterItemsById.salesPrice : '',
      purchasePrice: MasterItemsById ? MasterItemsById.purchasePrice : '',
      unitOfMeasure: MasterItemsById ? MasterItemsById.unitOfMeasure : '',
      image: MasterItemsById ? MasterItemsById.image : '',
      demandTimeUp: MasterItemsById ? MasterItemsById.demandTimeUp : '',
      demandTimeDown: MasterItemsById ? MasterItemsById.demandTimeDown : '',
      description: MasterItemsById ? MasterItemsById.description : '',
      discountRate: MasterItemsById ? MasterItemsById.discountRate : '',
      authorizeNegativeStock: MasterItemsById ? MasterItemsById.authorizeNegativeStock : false,
      brandId: MasterItemsById ? MasterItemsById.brandId : '',
      taxCategory: MasterItemsById ? MasterItemsById.taxCategory : '',
      expenseDistribute: MasterItemsById ? MasterItemsById.expenseDistribute : ''
    },
    enableReinitialize: true,
    validationSchema: MasterItemsSchema(t),
    onSubmit: values => {
      dispatch(
        UpdatMasterItems({
          id: values.id,
          itemCode: values.itemCode,
          barcode: values.barcode,
          name: values.name,
          name2: values.name2,
          categoryId: values.categoryId,
          brandId: values.brandId,
          itemType: values.itemType,
          serviceItemFlag: values.serviceItemFlag,
          isActive: values.isActive,
          purchasingEnabledFlag: values.purchasingEnabledFlag,
          customerOrderEnabledFlag: values.customerOrderEnabledFlag,
          internalOrderEnabledFlag: values.internalOrderEnabledFlag,
          soTransactionsFlag: values.soTransactionsFlag,
          invTransactionsEnabledFlag: values.invTransactionsEnabledFlag,
          salesPrice: values.salesPrice,
          purchasePrice: values.purchasePrice,
          unitOfMeasure: values.unitOfMeasure,
          image: values.image,
          demandTimeUp: values.demandTimeUp,
          demandTimeDown: values.demandTimeDown,
          description: values.description,
          discountRate: values.discountRate,
          authorizeNegativeStock: values.authorizeNegativeStock,

          displayName: values.displayName,
          displayName2: values.displayName2,
          taxCategory: values.taxCategory,
          // expenseDistribute: values.expenseDistribute,
          expenseDistribute: values.itemType === 'ExpenseItem' ? values.expenseDistribute : '',

          imagee: null
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded === true) {
            formik.resetForm();
            CustomAlert({ action: 'Edit' });
            formik.setSubmitting(false);
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res.message });
          }
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const fieldNames: Record<string, string> = {
    name2: t('LocalName'),
    purchasePrice: t('PurchasePrice'),
    salesPrice: t('SalesPrice'),
    name: t('GlobalName'),
    itemCode: t('ItemCode'),
    categoryId: t('ItemCategory'),
    barcode: t('Barcode'),
    itemType: t('ItemType'),
    unitOfMeasure: t('UnitOfMeasure'),
    // demandTimeUp: t('الحد الأعلى (كمية الطلب)'),
    // demandTimeDown: t('الحد الأدنى (كمية الطلب)')
    demandTimeUp: t('UpperDemandLimit'),
    demandTimeDown: t('LowerDemandLimit'),
    expenseDistribute: t('DistributionMethod')
  };

  return (
    <>
      <Loading loading={loading4}>
        <Form onSubmit={formik.handleSubmit}>
          {/* <Form onSubmit={handleFormSubmit}> */}

          <div className='p-0 '>
            <ul className='nav nav-tabs mb-4' role='tablist'>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'basic' ? 'active' : ''}`}
                  onClick={() => setActiveTab('basic')}
                  type='button'
                >
                  <i className='fas fa-info-circle me-2'></i>
                  {t('BasicInformation')}
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`nav-link ${activeTab === 'pricing' ? 'active' : ''}`}
                  onClick={() => setActiveTab('pricing')}
                  type='button'
                >
                  {/* <i className='fas fa-tag me-2'></i>
                  {t('Pricing')} */}
                  <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
                </button>
              </li>
            </ul>

            <div className='row'>
              <div className='col-xl-12'>
                <div className={`tab-pane ${activeTab === 'basic' ? 'show active' : 'd-none'}`}>
                  <Card>
                    <div className='card-header bg-light bg-opacity-30'>
                      <h5 className='mb-0'>
                        <i className='fas fa-info-circle me-2'></i>
                        {t('BasicInformation')}
                      </h5>
                    </div>

                    <CardBody>
                      <div className='row'>
                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('LocalName')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='name2'
                              onChange={formik.handleChange}
                              value={formik.values.name2 || ''}
                              isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                              placeholder={t('EnterLocalName')}
                            />
                            <Form.Control.Feedback type='invalid'>{formik.errors.name2 as any}</Form.Control.Feedback>
                          </div>
                        </div>
                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('GlobalName')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='name'
                              onChange={formik.handleChange}
                              value={formik.values.name || ''}
                              isInvalid={!!(formik.touched.name && formik.errors.name)}
                              placeholder={t('EnterGlobalName')}
                            />
                            <Form.Control.Feedback type='invalid'>{formik.errors.name as any}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <label className='form-label'>{t('Barcode')}</label>
                          <div className='input-group flex-nowrap'>
                            <span className='input-group-text'>
                              <i className='fas fa-barcode'></i>
                            </span>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='barcode'
                              onChange={formik.handleChange}
                              value={formik.values.barcode}
                              isInvalid={!!(formik.touched.barcode && formik.errors.barcode)}
                              placeholder={t('EnterBarcode')}
                            />

                            <button
                              type='button'
                              className='btn btn-outline-secondary'
                              onClick={generateBarcode}
                              title={t('GenerateBarcode')}
                            >
                              {loadBarcode ? (
                                <div className='spinner-border spinner-border-sm'></div>
                              ) : (
                                <i className='fa fa-magic'></i>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemCode')}</label>
                            <Form.Control
                              autoComplete='off'
                              className='form-control'
                              type='text'
                              name='itemCode'
                              onChange={formik.handleChange}
                              value={formik.values.itemCode || ''}
                              isInvalid={!!(formik.touched.itemCode && formik.errors.itemCode)}
                              placeholder={t('EnterItemCode')}
                            />
                            <Form.Control.Feedback type='invalid'>
                              {formik.errors.itemCode as any}
                            </Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemCategory')}</label>
                            <Form.Select
                              className='form-select'
                              name='categoryId'
                              onChange={formik.handleChange}
                              value={formik.values.categoryId || ''}
                              isInvalid={!!(formik.touched.categoryId && formik.errors.categoryId)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {CategoriesList &&
                                CategoriesList?.map((item, idx) => (
                                  <option key={++idx} value={item.id}>
                                    {i18n.language === 'en' ? item.name : item.name2}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>
                              {formik.errors.categoryId as any}
                            </Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label'>{t('Brand')}</label>
                            <Form.Select
                              className='form-select'
                              name='brandId'
                              onChange={formik.handleChange}
                              value={formik.values.brandId || ''}
                              isInvalid={!!(formik.touched.brandId && formik.errors.brandId)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {BrandListOptions &&
                                BrandListOptions?.map((item, idx) => (
                                  <option key={++idx} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>{formik.errors.brandId as any}</Form.Control.Feedback>
                          </div>
                        </div>

                        <div className='col-xl-6'>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('UnitOfMeasure')}</label>
                            <Form.Select
                              className='form-select'
                              name='unitOfMeasure'
                              onChange={formik.handleChange}
                              value={formik.values.unitOfMeasure || ''}
                              isInvalid={!!(formik.touched.unitOfMeasure && formik.errors.unitOfMeasure)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {UnitsOfMeasureList &&
                                UnitsOfMeasureList?.map((item, idx) => (
                                  <option key={++idx} value={item.id}>
                                    {i18n.language === 'en' ? item.name : item.name2}
                                  </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>
                              {formik.errors.unitOfMeasure as any}
                            </Form.Control.Feedback>
                          </div>
                        </div>

                        <div className={formik.values.itemType === 'ExpenseItem' ? 'col-xl-3' : 'col-xl-6'}>
                          <div className='form-group mb-3'>
                            <label className='form-label required-field'>{t('ItemType')}</label>
                            <Form.Select
                              className='form-select'
                              name='itemType'
                              onChange={formik.handleChange}
                              value={formik.values.itemType || ''}
                              isInvalid={!!(formik.touched.itemType && formik.errors.itemType)}
                            >
                              <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                              {ITEM_TYPE &&
                                ITEM_TYPE?.map((item: any, idx: number) =>
                                  item.list?.map((list: any) => (
                                    <option key={++idx} value={list.lookupCode}>
                                      {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                                    </option>
                                  ))
                                )}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid'>
                              {formik.errors.itemType as any}
                            </Form.Control.Feedback>
                          </div>
                        </div>
                        {formik.values.itemType === 'ExpenseItem' && (
                          <div className='col-xl-3'>
                            <div className='form-group mb-3'>
                              <label className='form-label required-field'>{t('DistributionMethod')}</label>
                              <Form.Select
                                className='form-select'
                                name='expenseDistribute'
                                onChange={formik.handleChange}
                                value={formik.values.expenseDistribute}
                                isInvalid={!!(formik.touched.expenseDistribute && formik.errors.expenseDistribute)}
                              >
                                <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                                {ExpenseDistribute &&
                                  ExpenseDistribute?.map((item: any, idx: number) =>
                                    item.list?.map((list: any) => (
                                      <option key={++idx} value={list.lookupCode}>
                                        {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                                      </option>
                                    ))
                                  )}
                              </Form.Select>
                              <Form.Control.Feedback type='invalid'>
                                {formik.errors.itemType as any}
                              </Form.Control.Feedback>
                            </div>
                          </div>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className={`tab-pane ${activeTab === 'pricing' ? 'show active' : 'd-none'}`}>
                  <div className='row'>
                    <div className='col-8'>
                      <Card>
                        <div className='card-header bg-light bg-opacity-30'>
                          <h5 className='mb-0'>
                            <i className='fas fa-tag me-2'></i>
                            {t('Pricing')}
                          </h5>
                        </div>

                        <CardBody>
                          <div className='row'>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('SalesPrice')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  step='0.01'
                                  name='salesPrice'
                                  onChange={formik.handleChange}
                                  value={formik.values.salesPrice || ''}
                                  isInvalid={!!(formik.touched.salesPrice && formik.errors.salesPrice)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.salesPrice as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('PurchasePrice')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  step='0.01'
                                  name='purchasePrice'
                                  onChange={formik.handleChange}
                                  value={formik.values.purchasePrice || ''}
                                  isInvalid={!!(formik.touched.purchasePrice && formik.errors.purchasePrice)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.purchasePrice as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('DiscountRate')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  max='100'
                                  step='0.01'
                                  name='discountRate'
                                  onChange={formik.handleChange}
                                  value={formik.values.discountRate || ''}
                                  isInvalid={!!(formik.touched.discountRate && formik.errors.discountRate)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.discountRate as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('UpperDemandLimit')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  name='demandTimeUp'
                                  onChange={formik.handleChange}
                                  value={formik.values.demandTimeUp || ''}
                                  isInvalid={!!(formik.touched.demandTimeUp && formik.errors.demandTimeUp)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.demandTimeUp as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label'>{t('LowerDemandLimit')}</label>
                                <Form.Control
                                  autoComplete='off'
                                  className='form-control'
                                  type='number'
                                  min='0'
                                  name='demandTimeDown'
                                  onChange={formik.handleChange}
                                  value={formik.values.demandTimeDown || ''}
                                  isInvalid={!!(formik.touched.demandTimeDown && formik.errors.demandTimeDown)}
                                />
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.demandTimeDown as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>

                            <div className='col-xl-6'>
                              <div className='form-group mb-3'>
                                <label className='form-label required-field'>{t('TaxCategory')}</label>
                                <Form.Select
                                  className='form-select'
                                  name='taxCategory'
                                  onChange={formik.handleChange}
                                  value={formik.values.taxCategory}
                                  isInvalid={!!(formik.touched.taxCategory && formik.errors.taxCategory)}
                                >
                                  <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                                  {TaxCategory &&
                                    TaxCategory?.map((item: any, idx: number) =>
                                      item.list?.map((list: any) => (
                                        <option key={++idx} value={list.lookupCode}>
                                          {i18n.language === 'en' ? list.meaning : list.meaning2}
                                        </option>
                                      ))
                                    )}
                                </Form.Select>
                                <Form.Control.Feedback type='invalid'>
                                  {formik.errors.itemType as any}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                    <div className='col-4'>
                      <div className='col-xl-12'>
                        <Card>
                          <div className='card-header bg-light bg-opacity-30'>
                            <h5 className='mb-0'>
                              <i className='fas fa-cog me-2'></i> {t('ItemSettings')}
                            </h5>
                          </div>
                          <div className='card-body'>
                            <div className='settings-container'>
                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='isActive'
                                  checked={formik.values.isActive || false}
                                  onChange={formik.handleChange}
                                  id='isActiveSwitch'
                                />
                                <label className='form-check-label' htmlFor='isActiveSwitch'>
                                  {t('Active')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='serviceItemFlag'
                                  checked={formik.values.serviceItemFlag || false}
                                  onChange={formik.handleChange}
                                  id='serviceItemSwitch'
                                />
                                <label className='form-check-label' htmlFor='serviceItemSwitch'>
                                  {t('ServiceItem')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='invTransactionsEnabledFlag'
                                  checked={formik.values.invTransactionsEnabledFlag || false}
                                  onChange={formik.handleChange}
                                  id='trackInventorySwitch'
                                />
                                <label className='form-check-label' htmlFor='trackInventorySwitch'>
                                  {t('TrackInventory')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='customerOrderEnabledFlag'
                                  checked={formik.values.customerOrderEnabledFlag || false}
                                  onChange={formik.handleChange}
                                  id='customerOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='customerOrdersSwitch'>
                                  {t('EnableCustomerOrders')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='soTransactionsFlag'
                                  checked={formik.values.soTransactionsFlag || false}
                                  onChange={formik.handleChange}
                                  id='salesOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='salesOrdersSwitch'>
                                  {t('AvailableForSale')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='purchasingEnabledFlag'
                                  checked={formik.values.purchasingEnabledFlag || false}
                                  onChange={formik.handleChange}
                                  id='purchasingSwitch'
                                />
                                <label className='form-check-label' htmlFor='purchasingSwitch'>
                                  {t('EnablePurchasing')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  type='checkbox'
                                  className='form-check-input'
                                  name='internalOrderEnabledFlag'
                                  checked={formik.values.internalOrderEnabledFlag || false}
                                  onChange={formik.handleChange}
                                  id='internalOrdersSwitch'
                                />
                                <label className='form-check-label' htmlFor='internalOrdersSwitch'>
                                  {t('InternalTransfer')}
                                </label>
                              </div>

                              <div className='form-check form-switch mb-3'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='authorizeNegativeStock'
                                  checked={formik.values.authorizeNegativeStock || false}
                                  onChange={formik.handleChange}
                                  id='negativeStockSwitch'
                                />
                                <label className='form-check-label' htmlFor='negativeStockSwitch'>
                                  {t('AllowNegativeStock')}
                                </label>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {Object.keys(formik.errors).length > 0 && (
              <div className='alert alert-danger mt-3 border rounded-2 shadow-sm' role='alert'>
                <h6 className='mb-1 text-danger'>
                  <i className='bi bi-exclamation-triangle-fill me-2'></i>
                  {i18n.language === 'en' ? 'Please review the following fields:' : '  يُرجى مراجعة الحقول التالية:'}
                </h6>
                <ul className='mb-0 ps-4 mt-2'>
                  {Object.entries(formik.errors).map(([field, error]) => (
                    <li key={field} className='small'>
                      <strong>{fieldNames[field] ?? field}:</strong> <span className='fw-normal'>{error as any}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className='d-flex justify-content-center mt-4'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1  rounded-1'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fa fa-save fa-fw me-1'></i>
                )}
                {t('Save')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default Update;

//  <li className='nav-item'>
//               <button
//                 className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
//                 onClick={() => setActiveTab('settings')}
//                 type='button'
//               >
//                 <i className='fas fa-cog me-2'></i>
//                 {t('Settings')}
//               </button>
//             </li>

//     <div className={`tab-pane ${activeTab === 'settings' ? 'show active' : 'd-none'}`}>
//                 <div className='row'>
//                   <div className='col-12'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('Note')}</label>
//                       <Form.Control
//                         as='textarea'
//                         rows={3}
//                         autoComplete='off'
//                         className='form-control'
//                         name='description'
//                         onChange={formik.handleChange}
//                         value={formik.values.description}
//                         isInvalid={!!(formik.touched.description && formik.errors.description)}
//                       />
//                     </div>
//                   </div>

//                   {(formik.values.soTransactionsFlag || formik.values.customerOrderEnabledFlag) && (
//                     <>
//                       <div className='col-xl-6'>
//                         <div className='form-group mb-3'>
//                           <label className='form-label'>{t('LocalDisplayName')}</label>
//                           <Form.Control
//                             autoComplete='off'
//                             className='form-control'
//                             type='text'
//                             name='displayName2'
//                             onChange={formik.handleChange}
//                             value={formik.values.displayName2}
//                             isInvalid={!!(formik.touched.displayName2 && formik.errors.displayName2)}
//                           />
//                           <Form.Control.Feedback type='invalid'>{formik.errors.displayName2}</Form.Control.Feedback>
//                         </div>
//                       </div>
//                       <div className='col-xl-6'>
//                         <div className='form-group mb-3'>
//                           <label className='form-label'>{t('GlobalDisplayName')}</label>
//                           <Form.Control
//                             autoComplete='off'
//                             className='form-control'
//                             type='text'
//                             name='displayName'
//                             onChange={formik.handleChange}
//                             value={formik.values.displayName}
//                             isInvalid={!!(formik.touched.displayName && formik.errors.displayName)}
//                           />
//                           <Form.Control.Feedback type='invalid'>{formik.errors.displayName}</Form.Control.Feedback>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
